import { useCustom } from '@refinedev/core';
import { Card, Typography } from 'antd';
import { Column } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { MonetizationProductMixOut } from '@/api/generated/schemas';
import { cleanFilters, type MonetizationStatsFilters } from './filters';

type Props = { filters: MonetizationStatsFilters };

type MixRow = {
  label: string;
  account_count: number;
  tier: string;
};

const productLabel = (row: MonetizationProductMixOut): string =>
  row.display_name || row.store_product_identifier || `#${row.product_id}`;

export const MonetizationProductMixChart = ({ filters }: Props) => {
  const { query } = useCustom<MonetizationProductMixOut[]>({
    url: 'monetization/subscriptions/stats/product_mix',
    method: 'get',
    config: { query: cleanFilters(filters) },
  });

  const rows = query.data?.data ?? [];
  const data: MixRow[] = rows
    .map((r) => ({
      label: productLabel(r),
      account_count: r.account_count,
      tier: r.tier,
    }))
    .sort((a, b) => b.account_count - a.account_count);

  return (
    <Card title="Mix produktów" loading={query.isLoading}>
      {data.length > 0 ? (
        <Column
          data={data}
          xField="label"
          yField="account_count"
          colorField="tier"
          height={280}
          legend={BOTTOM_LEGEND}
          axis={{ x: { labelAutoRotate: true } }}
        />
      ) : (
        <Typography.Text type="secondary">Brak danych</Typography.Text>
      )}
    </Card>
  );
};
